// extracted by mini-css-extract-plugin
export default {"splineContainer":"Home_splineContainer__adCze"};